import classNames from 'classnames';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { BackButton } from '../BackButton';
import { CloseButton } from '../CloseButton';

const Container = styled.div`
  display: grid;
  grid-template-areas: 'left center right';
  grid-template-columns: 40px 1fr 40px;
  align-items: center;
  padding: var(--double-unit);
  &.withDivider {
    border-bottom: 1px solid var(--c-nd-150);
  }
`;
const Left = styled.div`
  grid-area: left;
`;
const Center = styled.div`
  grid-area: center;
  overflow: hidden;
`;
const Right = styled.div`
  grid-area: right;
`;

type Props = {
  onBack?: () => void;
  onClose?: () => void;
  title?: ReactNode;
  transparentButton?: boolean;
  withDivider?: boolean;
};

export const Header = ({
  onBack,
  title,
  onClose,
  transparentButton,
  withDivider,
}: Props) => (
  <Container className={classNames({ withDivider })}>
    <Left>{onBack && <BackButton onBack={onBack} />}</Left>
    <Center>{title}</Center>
    <Right>
      {onClose && (
        <CloseButton onClose={onClose} transparent={transparentButton} />
      )}
    </Right>
  </Container>
);
